import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Sidebar from './Sidebar';



const AdminLayout = ({ onChange ,children, isAdmin, questionCount }) => (

    <Grid className="admin-wrapper wideLayout">
      <Row className="admin-header">
        <Sidebar onChangeLayout={onChange} isAdmin={isAdmin} questionCount={questionCount}  />
      </Row>
      <Row>
        <Col xs={12} sm={12} md={12} className="admin-content">
          {children}
        </Col>
      </Row>
    </Grid>

);

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  questionCount: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AdminLayout;



// WEBPACK FOOTER //
// ./src/features/admin/components/AdminLayout.js